export default "__VITE_ASSET__0db796e9__"